import { Typography } from "@packages/ds";
import styled, { css } from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export interface ActionProps {
  isSortActive?: boolean;
  sortable?: boolean;
}

export const Action = styled(Typography.Label)<ActionProps>`
  ${({ sortable }) =>
    sortable &&
    css`
      display: flex;
      align-items: center;
      background-color: transparent;
      outline: none;
      border: none;
      margin: 0;
      cursor: pointer;
      padding: 0;

      [fill] {
        fill: var(--mode-vector-neutral-default);
      }

      :hover {
        [fill] {
          fill: var(--mode-vector-neutral-strong);
        }
      }
    `};

  ${({ isSortActive }) =>
    isSortActive &&
    css`
      [fill] {
        fill: var(--mode-vector-primary-default);
      }

      :hover {
        [fill] {
          fill: var(--mode-vector-primary-strong);
        }
      }
    `}
`;

export interface LayoutProps {
  width?: string;
}

export const Layout = styled.div<LayoutProps>`
  ${semiBoldAlias()};
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;

  ${({ width }) => width && `flex-basis: ${width};`};
`;
